import { routes } from "@/routes";
import {
  FaqItem,
  FooterLinkSection,
  FooterSocialLink,
  IBaseIconLabel,
  ICategories,
  IContactSupport,
  IOurValueItem,
  IRawSettingsResData,
  ISelectableBaseProps,
  IServiceCard,
  IStepCardProps,
  TDatePartKey,
  TeamMember,
  TRawServiceApiKeys,
  TServiceNavigationItem,
} from "@/interfaces";
import { cn, faToEnDigits, nanoid, toUrlFriendly } from "@/lib";
import {
  BdBanknote2,
  BdBillList,
  BdCalendar,
  BdCalculator,
  BdClipboardCheck,
  BdHome,
  BdMailbox,
  BdMinimalisticMagnifer,
  BdSquareTransferHorizontal,
  BdWadOfMoney,
  BdWidget,
} from "solar-icon-react/bd";
import {
  OlClockCircle,
  OlHourglass,
  OlLayers,
  OlMapPointWave,
  OlUsersGroupRounded,
} from "solar-icon-react/ol";
import Image01 from "@public/image01.jpg";
import Image02 from "@public/image02.jpg";
import Image03 from "@public/image03.jpg";
import ZibalImage2 from "public/zibal.png";
import SadadImage from "public/sadad-2.png";
import { contactUsConfig } from "@/config";
import { globalRawServicesData } from "./globalRawServicesData/globalRawServicesData";
import LinkedinIcon from "@/components/ui/icons/linkedin";
import TwitterIcon from "@/components/ui/icons/twitter";
import InstagramIcon from "@/components/ui/icons/instagram";
import AparatIcon from "@/components/ui/icons/aparat";
import TelegramIcon from "@/components/ui/icons/telegram";
import BotIcon from "@/components/ui/icons/bot";

export * from "./faq";
export * from "./features";
export * from "./resolver";

export const infoSectionFeatures: string[] = [
  "infoSectionFeatures.highSecurity",
  "infoSectionFeatures.simpleUI",
  "infoSectionFeatures.fastSupport",
];

export const landingQuickAccessNavigation: TServiceNavigationItem[] = [
  {
    id: nanoid(),
    label: globalRawServicesData.Fines.label.adapted,
    key: globalRawServicesData.Fines.key,
    apiKey: globalRawServicesData.Fines.api.apiKey,
    disable: false,
    href: routes.services.Fines.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Iban_Inquiry.label.adapted,
    key: globalRawServicesData.Iban_Inquiry.key,
    apiKey: globalRawServicesData.Iban_Inquiry.api.apiKey,
    disable: false,
    href: routes.services.Iban_Inquiry.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Card_Inquiry.label.adapted,
    key: globalRawServicesData.Card_Inquiry.key,
    apiKey: globalRawServicesData.Card_Inquiry.api.apiKey,
    disable: false,
    href: routes.services.Card_Inquiry.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Bounced_Check.label.adapted,
    key: globalRawServicesData.Bounced_Check.key,
    apiKey: globalRawServicesData.Bounced_Check.api.apiKey,
    disable: false,
    href: routes.services.Bounced_Check.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Passport_Status.label.adapted,
    key: globalRawServicesData.Passport_Status.key,
    apiKey: globalRawServicesData.Passport_Status.api.apiKey,
    disable: false,
    href: routes.services.Passport_Status.rewritePath,
  },
];

export const servicesQuickAccessNavigation: TServiceNavigationItem[] = [
  {
    id: nanoid(),
    label: globalRawServicesData.Iban_Inquiry.label.adapted,
    key: globalRawServicesData.Iban_Inquiry.key,
    apiKey: globalRawServicesData.Iban_Inquiry.api.apiKey,
    disable: false,
    href: routes.services.Iban_Inquiry.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Card_Inquiry.label.adapted,
    key: globalRawServicesData.Card_Inquiry.key,
    apiKey: globalRawServicesData.Card_Inquiry.api.apiKey,
    disable: false,
    href: routes.services.Card_Inquiry.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Card_To_Iban.label.adapted,
    key: globalRawServicesData.Card_To_Iban.key,
    apiKey: globalRawServicesData.Card_To_Iban.api.apiKey,
    disable: false,
    href: routes.services.Card_To_Iban.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Account_To_Iban.label.adapted,
    key: globalRawServicesData.Account_To_Iban.key,
    apiKey: globalRawServicesData.Account_To_Iban.api.apiKey,
    disable: false,
    href: routes.services.Account_To_Iban.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Card_To_Account.label.adapted,
    key: globalRawServicesData.Card_To_Account.key,
    apiKey: globalRawServicesData.Card_To_Account.api.apiKey,
    disable: false,
    href: routes.services.Card_To_Account.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Active_Loans.label.adapted,
    key: globalRawServicesData.Active_Loans.key,
    apiKey: globalRawServicesData.Active_Loans.api.apiKey,
    disable: false,
    href: routes.services.Active_Loans.rewritePath,
  },
];

export const chequeServicesQuickAccessNavigation: TServiceNavigationItem[] = [
  {
    id: nanoid(),
    label: globalRawServicesData.Bounced_Check.label.adapted,
    key: globalRawServicesData.Bounced_Check.key,
    apiKey: globalRawServicesData.Bounced_Check.api.apiKey,
    disable: false,
    href: routes.services.Bounced_Check.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Cheque_Inquiry.label.adapted,
    key: globalRawServicesData.Cheque_Inquiry.key,
    apiKey: globalRawServicesData.Cheque_Inquiry.api.apiKey,
    disable: false,
    href: routes.services.Cheque_Inquiry.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Cheque_V2_Inquiry.label.adapted,
    key: globalRawServicesData.Cheque_V2_Inquiry.key,
    apiKey: globalRawServicesData.Cheque_V2_Inquiry.api.apiKey,
    disable: false,
    href: routes.services.Cheque_V2_Inquiry.rewritePath,
  },
  {
    id: "back-cheques-full",
    label: "استعلام چک برگشتی با جزئیات کامل",
    key: "Back-Cheques-Full",
    apiKey: "back_cheques" as unknown as TRawServiceApiKeys,
    disable: false,
    href: "/services/استعلام-چک-برگشتی-با-جزئیات-کامل",
  },
];

export const carServicesQuickAccessNavigation: TServiceNavigationItem[] = [
  {
    id: nanoid(),
    label: globalRawServicesData.Fines.label.adapted,
    key: globalRawServicesData.Fines.key,
    apiKey: globalRawServicesData.Fines.api.apiKey,
    disable: false,
    href: routes.services.Fines.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Vehicle_Transfer_Tax.label.adapted,
    key: globalRawServicesData.Vehicle_Transfer_Tax.key,
    apiKey: globalRawServicesData.Vehicle_Transfer_Tax.api.apiKey,
    disable: false,
    href: routes.services.Vehicle_Transfer_Tax.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Fines_Photo.label.adapted,
    key: globalRawServicesData.Fines_Photo.key,
    apiKey: globalRawServicesData.Fines_Photo.api.apiKey,
    disable: false,
    href: routes.services.Fines_Photo.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Motorcycle_Fines.label.adapted,
    key: globalRawServicesData.Motorcycle_Fines.key,
    apiKey: globalRawServicesData.Motorcycle_Fines.api.apiKey,
    disable: false,
    href: routes.services.Motorcycle_Fines.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Car_Document_Inquiry.label.adapted,
    key: globalRawServicesData.Car_Document_Inquiry.key,
    apiKey: globalRawServicesData.Car_Document_Inquiry.api.apiKey,
    disable: false,
    href: routes.services.Car_Document_Inquiry.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Plate_Inquiry.label.adapted,
    key: globalRawServicesData.Plate_Inquiry.key,
    apiKey: globalRawServicesData.Plate_Inquiry.api.apiKey,
    disable: false,
    href: routes.services.Plate_Inquiry.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Freeway_Toll.label.adapted,
    key: globalRawServicesData.Freeway_Toll.key,
    apiKey: globalRawServicesData.Freeway_Toll.api.apiKey,
    disable: false,
    href: routes.services.Freeway_Toll.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Vehicle_Info.label.adapted,
    key: globalRawServicesData.Vehicle_Info.key,
    apiKey: globalRawServicesData.Vehicle_Info.api.apiKey,
    disable: false,
    href: routes.services.Vehicle_Info.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Third_Party_Insurance.label.adapted,
    key: globalRawServicesData.Third_Party_Insurance.key,
    apiKey: globalRawServicesData.Third_Party_Insurance.api.apiKey,
    disable: false,
    href: routes.services.Third_Party_Insurance.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Driving_License_Status.label.adapted,
    key: globalRawServicesData.Driving_License_Status.key,
    apiKey: globalRawServicesData.Driving_License_Status.api.apiKey,
    disable: false,
    href: routes.services.Driving_License_Status.rewritePath,
  },
];

// Function to generate bank-specific navigation items
export const generateBankNavigationItems = (
  bankName: string,
): TServiceNavigationItem[] => [
  {
    id: nanoid(),
    label: globalRawServicesData.Iban_Inquiry.label.adapted,
    key: globalRawServicesData.Iban_Inquiry.key,
    apiKey: globalRawServicesData.Iban_Inquiry.api.apiKey,
    disable: false,
    href: `${routes.services.Iban_Inquiry.rewritePath}/${toUrlFriendly(bankName)}`,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Card_Inquiry.label.adapted,
    key: globalRawServicesData.Card_Inquiry.key,
    apiKey: globalRawServicesData.Card_Inquiry.api.apiKey,
    disable: false,
    href: `${routes.services.Card_Inquiry.rewritePath}/${toUrlFriendly(bankName)}`,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Card_To_Iban.label.adapted,
    key: globalRawServicesData.Card_To_Iban.key,
    apiKey: globalRawServicesData.Card_To_Iban.api.apiKey,
    disable: false,
    href: `${routes.services.Card_To_Iban.rewritePath}/${toUrlFriendly(bankName)}`,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Account_To_Iban.label.adapted,
    key: globalRawServicesData.Account_To_Iban.key,
    apiKey: globalRawServicesData.Account_To_Iban.api.apiKey,
    disable: false,
    href: `${routes.services.Account_To_Iban.rewritePath}/${toUrlFriendly(bankName)}`,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Card_To_Account.label.adapted,
    key: globalRawServicesData.Card_To_Account.key,
    apiKey: globalRawServicesData.Card_To_Account.api.apiKey,
    disable: false,
    href: `${routes.services.Card_To_Account.rewritePath}/${toUrlFriendly(bankName)}`,
  },
];

export const legalServicesQuickAccessNavigation: TServiceNavigationItem[] = [
  {
    id: nanoid(),
    label: globalRawServicesData.Company_Information_Inquiry.label.adapted,
    key: globalRawServicesData.Company_Information_Inquiry.key,
    apiKey: globalRawServicesData.Company_Information_Inquiry.api.apiKey,
    disable: false,
    href: routes.services.Company_Information_Inquiry.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Tax_Records_Inquiry.label.adapted,
    key: globalRawServicesData.Tax_Records_Inquiry.key,
    apiKey: globalRawServicesData.Tax_Records_Inquiry.api.apiKey,
    disable: false,
    href: routes.services.Tax_Records_Inquiry.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Company_Members_Inquiry.label.adapted,
    key: globalRawServicesData.Company_Members_Inquiry.key,
    apiKey: globalRawServicesData.Company_Members_Inquiry.api.apiKey,
    disable: false,
    href: routes.services.Company_Members_Inquiry.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Company_Newspaper_inquiry.label.adapted,
    key: globalRawServicesData.Company_Newspaper_inquiry.key,
    apiKey: globalRawServicesData.Company_Newspaper_inquiry.api.apiKey,
    disable: false,
    href: routes.services.Company_Newspaper_inquiry.rewritePath,
  },
  // {
  //   id: nanoid(),
  //   label: globalRawServicesData.Company_Parent_Inquiry.label.adapted,
  //   key: globalRawServicesData.Company_Parent_Inquiry.key,
  //   apiKey: globalRawServicesData.Company_Parent_Inquiry.api.apiKey,
  //   disable: true,
  //   // href: routes.services.Company_Parent_Inquiry.rewritePath,
  //   href: "#",
  // },
  // {
  //   id: nanoid(),
  //   label: globalRawServicesData.Company_Children_Inquiry.label.adapted,
  //   key: globalRawServicesData.Company_Children_Inquiry.key,
  //   apiKey: globalRawServicesData.Company_Children_Inquiry.api.apiKey,
  //   disable: true,
  //   // href: routes.services.Company_Children_Inquiry.rewritePath,
  //   href: "#",
  // },
  // {
  //   id: nanoid(),
  //   label: globalRawServicesData.Company_Licenses_Inquiry.label.adapted,
  //   key: globalRawServicesData.Company_Licenses_Inquiry.key,
  //   apiKey: globalRawServicesData.Company_Licenses_Inquiry.api.apiKey,
  //   disable: true,
  //   // href: routes.services.Company_Licenses_Inquiry.rewritePath,
  //   href: "#",
  // },
  // {
  //   id: nanoid(),
  //   label: globalRawServicesData.Company_Owners_Inquiry.label.adapted,
  //   key: globalRawServicesData.Company_Owners_Inquiry.key,
  //   apiKey: globalRawServicesData.Company_Owners_Inquiry.api.apiKey,
  //   disable: true,
  //   href: routes.services.Company_Owners_Inquiry.rewritePath,
  // },
  // {
  //   id: nanoid(),
  //   label: globalRawServicesData.Official_Gazette_Inquiry.label.adapted,
  //   key: globalRawServicesData.Official_Gazette_Inquiry.key,
  //   apiKey: globalRawServicesData.Official_Gazette_Inquiry.api.apiKey,
  //   disable: true,
  //   href: routes.services.Official_Gazette_Inquiry.rewritePath,
  // },
];

export const noNavigateServices: TServiceNavigationItem[] = [
  {
    id: nanoid(),
    label: globalRawServicesData.Military_Service_Status.label.adapted,
    key: globalRawServicesData.Military_Service_Status.key,
    apiKey: globalRawServicesData.Military_Service_Status.api.apiKey,
    href: routes.services.Military_Service_Status.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Military_Card_Status.label.adapted,
    key: globalRawServicesData.Military_Card_Status.key,
    apiKey: globalRawServicesData.Military_Card_Status.api.apiKey,
    href: routes.services.Military_Card_Status.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Educational_Exemption.label.adapted,
    key: globalRawServicesData.Educational_Exemption.key,
    apiKey: globalRawServicesData.Educational_Exemption.api.apiKey,
    href: routes.services.Educational_Exemption.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Postal_Code_Inquiry.label.adapted,
    key: globalRawServicesData.Postal_Code_Inquiry.key,
    apiKey: globalRawServicesData.Postal_Code_Inquiry.api.apiKey,
    href: routes.services.Postal_Code_Inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Bounced_Check.label.adapted,
    key: globalRawServicesData.Bounced_Check.key,
    apiKey: globalRawServicesData.Bounced_Check.api.apiKey,
    href: routes.services.Bounced_Check.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Fines.label.adapted,
    key: globalRawServicesData.Fines.key,
    apiKey: globalRawServicesData.Fines.api.apiKey,
    href: routes.services.Fines.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Vehicle_Transfer_Tax.label.adapted,
    key: globalRawServicesData.Vehicle_Transfer_Tax.key,
    apiKey: globalRawServicesData.Vehicle_Transfer_Tax.api.apiKey,
    href: routes.services.Vehicle_Transfer_Tax.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Freeway_Toll.label.adapted,
    key: globalRawServicesData.Freeway_Toll.key,
    apiKey: globalRawServicesData.Freeway_Toll.api.apiKey,
    href: routes.services.Freeway_Toll.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Vehicle_Info.label.adapted,
    key: globalRawServicesData.Vehicle_Info.key,
    apiKey: globalRawServicesData.Vehicle_Info.api.apiKey,
    href: routes.services.Vehicle_Info.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Third_Party_Insurance.label.adapted,
    key: globalRawServicesData.Third_Party_Insurance.key,
    apiKey: globalRawServicesData.Third_Party_Insurance.api.apiKey,
    href: routes.services.Third_Party_Insurance.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Fines_Photo.label.adapted,
    key: globalRawServicesData.Fines_Photo.key,
    apiKey: globalRawServicesData.Fines_Photo.api.apiKey,
    href: routes.services.Fines_Photo.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Motorcycle_Fines.label.adapted,
    key: globalRawServicesData.Motorcycle_Fines.key,
    apiKey: globalRawServicesData.Motorcycle_Fines.api.apiKey,
    href: routes.services.Motorcycle_Fines.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Plate_Inquiry.label.adapted,
    key: globalRawServicesData.Plate_Inquiry.key,
    apiKey: globalRawServicesData.Plate_Inquiry.api.apiKey,
    disable: false,
    href: routes.services.Plate_Inquiry.rewritePath,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Negative_Points.label.adapted,
    key: globalRawServicesData.Negative_Points.key,
    apiKey: globalRawServicesData.Negative_Points.api.apiKey,
    href: routes.services.Negative_Points.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Driving_License_Status.label.adapted,
    key: globalRawServicesData.Driving_License_Status.key,
    apiKey: globalRawServicesData.Driving_License_Status.api.apiKey,
    href: routes.services.Driving_License_Status.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Passport_Status.label.adapted,
    key: globalRawServicesData.Passport_Status.key,
    apiKey: globalRawServicesData.Passport_Status.api.apiKey,
    href: routes.services.Passport_Status.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Sana_Inquiry.label.adapted,
    key: globalRawServicesData.Sana_Inquiry.key,
    apiKey: globalRawServicesData.Sana_Inquiry.api.apiKey,
    href: routes.services.Sana_Inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Bank_Validation.label.adapted,
    key: globalRawServicesData.Bank_Validation.key,
    apiKey: globalRawServicesData.Bank_Validation.api.apiKey,
    href: routes.services.Bank_Validation.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Identity_Inquiry.label.adapted,
    key: globalRawServicesData.Identity_Inquiry.key,
    apiKey: globalRawServicesData.Identity_Inquiry.api.apiKey,
    href: routes.services.Identity_Inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Foreigners_Inquiry.label.adapted,
    key: globalRawServicesData.Foreigners_Inquiry.key,
    apiKey: globalRawServicesData.Foreigners_Inquiry.api.apiKey,
    href: routes.services.Foreigners_Inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Company_Licenses_Inquiry.label.adapted,
    key: globalRawServicesData.Company_Licenses_Inquiry.key,
    apiKey: globalRawServicesData.Company_Licenses_Inquiry.api.apiKey,
    href: routes.services.Company_Licenses_Inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Company_Parent_Inquiry.label.adapted,
    key: globalRawServicesData.Company_Parent_Inquiry.key,
    apiKey: globalRawServicesData.Company_Parent_Inquiry.api.apiKey,
    href: routes.services.Company_Parent_Inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Company_Children_Inquiry.label.adapted,
    key: globalRawServicesData.Company_Children_Inquiry.key,
    apiKey: globalRawServicesData.Company_Children_Inquiry.api.apiKey,
    href: routes.services.Company_Children_Inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Corporation_Identity_Inquiry.label.adapted,
    key: globalRawServicesData.Corporation_Identity_Inquiry.key,
    apiKey: globalRawServicesData.Corporation_Identity_Inquiry.api.apiKey,
    href: routes.services.Corporation_Identity_Inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Car_Document_Inquiry.label.adapted,
    key: globalRawServicesData.Car_Document_Inquiry.key,
    apiKey: globalRawServicesData.Car_Document_Inquiry.api.apiKey,
    href: routes.services.Car_Document_Inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Cheque_Inquiry.label.adapted,
    key: globalRawServicesData.Cheque_Inquiry.key,
    apiKey: globalRawServicesData.Cheque_Inquiry.api.apiKey,
    href: routes.services.Cheque_Inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Cheque_V2_Inquiry.label.adapted,
    key: globalRawServicesData.Cheque_V2_Inquiry.key,
    apiKey: globalRawServicesData.Cheque_V2_Inquiry.api.apiKey,
    href: routes.services.Cheque_V2_Inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Transfer_Chain_Inquiry.label.adapted,
    key: globalRawServicesData.Transfer_Chain_Inquiry.key,
    apiKey: globalRawServicesData.Transfer_Chain_Inquiry.api.apiKey,
    href: routes.services.Transfer_Chain_Inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Postal_Tracking_Inquiry.label.adapted,
    key: globalRawServicesData.Postal_Tracking_Inquiry.key,
    apiKey: globalRawServicesData.Postal_Tracking_Inquiry.api.apiKey,
    href: routes.services.Postal_Tracking_Inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Electricity_Bill_inquiry.label.adapted,
    key: globalRawServicesData.Electricity_Bill_inquiry.key,
    apiKey: globalRawServicesData.Electricity_Bill_inquiry.api.apiKey,
    href: routes.services.Electricity_Bill_inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Electricity_Bill_Info_inquiry.label.adapted,
    key: globalRawServicesData.Electricity_Bill_Info_inquiry.key,
    apiKey: globalRawServicesData.Electricity_Bill_Info_inquiry.api.apiKey,
    href: routes.services.Electricity_Bill_Info_inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Gas_Bill_inquiry.label.adapted,
    key: globalRawServicesData.Gas_Bill_inquiry.key,
    apiKey: globalRawServicesData.Gas_Bill_inquiry.api.apiKey,
    href: routes.services.Gas_Bill_inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Gas_Bill_Info_inquiry.label.adapted,
    key: globalRawServicesData.Gas_Bill_Info_inquiry.key,
    apiKey: globalRawServicesData.Gas_Bill_Info_inquiry.api.apiKey,
    href: routes.services.Gas_Bill_Info_inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Water_Bill_inquiry.label.adapted,
    key: globalRawServicesData.Water_Bill_inquiry.key,
    apiKey: globalRawServicesData.Water_Bill_inquiry.api.apiKey,
    href: routes.services.Water_Bill_inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Water_Bill_Info_inquiry.label.adapted,
    key: globalRawServicesData.Water_Bill_Info_inquiry.key,
    apiKey: globalRawServicesData.Water_Bill_Info_inquiry.api.apiKey,
    href: routes.services.Water_Bill_Info_inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Electricity_Bill_History_inquiry.label.adapted,
    key: globalRawServicesData.Electricity_Bill_History_inquiry.key,
    apiKey: globalRawServicesData.Electricity_Bill_History_inquiry.api.apiKey,
    href: routes.services.Electricity_Bill_History_inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Electricity_Bill_Image_inquiry.label.adapted,
    key: globalRawServicesData.Electricity_Bill_Image_inquiry.key,
    apiKey: globalRawServicesData.Electricity_Bill_Image_inquiry.api.apiKey,
    href: routes.services.Electricity_Bill_Image_inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Gas_Bill_History_inquiry.label.adapted,
    key: globalRawServicesData.Gas_Bill_History_inquiry.key,
    apiKey: globalRawServicesData.Gas_Bill_History_inquiry.api.apiKey,
    href: routes.services.Gas_Bill_History_inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Phone_Bill_Image_inquiry.label.adapted,
    key: globalRawServicesData.Phone_Bill_Image_inquiry.key,
    apiKey: globalRawServicesData.Phone_Bill_Image_inquiry.api.apiKey,
    href: routes.services.Phone_Bill_Image_inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Phone_Bill_inquiry.label.adapted,
    key: globalRawServicesData.Phone_Bill_inquiry.key,
    apiKey: globalRawServicesData.Phone_Bill_inquiry.api.apiKey,
    href: routes.services.Phone_Bill_inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Mobile_Bill_Mci_inquiry.label.adapted,
    key: globalRawServicesData.Mobile_Bill_Mci_inquiry.key,
    apiKey: globalRawServicesData.Mobile_Bill_Mci_inquiry.api.apiKey,
    href: routes.services.Mobile_Bill_Mci_inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Mobile_Bill_Rightel_inquiry.label.adapted,
    key: globalRawServicesData.Mobile_Bill_Rightel_inquiry.key,
    apiKey: globalRawServicesData.Mobile_Bill_Rightel_inquiry.api.apiKey,
    href: routes.services.Mobile_Bill_Rightel_inquiry.rewritePath,
    disable: false,
  },
  {
    id: nanoid(),
    label: globalRawServicesData.Mobile_Bill_Mtn_inquiry.label.adapted,
    key: globalRawServicesData.Mobile_Bill_Mtn_inquiry.key,
    apiKey: globalRawServicesData.Mobile_Bill_Mtn_inquiry.api.apiKey,
    href: routes.services.Mobile_Bill_Mtn_inquiry.rewritePath,
    disable: false,
  },
];

export const servicesCategories: ICategories[] = [
  {
    key: "banking",
    id: nanoid(),
    category: "bankingServices",
    href: "#",
    variant: "emerald-mint",
    icon: <BdBanknote2 className="size-full! text-white!" />,
  },
  {
    key: "vehicle",
    id: nanoid(),
    category: "vehicleServices",
    href: "#",
    variant: "sky-bliss",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 24 24"
      >
        <path
          fill="white"
          d="M14.5 19.982c1.573-.04 2.677-.167 3.5-.567V21a1 1 0 0 1-1 1h-1.5a1 1 0 0 1-1-1zM6 19.415c.823.4 1.927.527 3.5.567V21a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z"
        />
        <path
          fill="white"
          fillRule="evenodd"
          d="M5.172 3.172C6.343 2 8.229 2 12 2s5.657 0 6.828 1.172C19.892 4.235 19.99 5.886 20 9v4c-.01 3.114-.108 4.765-1.172 5.828a3 3 0 0 1-.828.587c-.823.4-1.927.527-3.5.567C13.773 20 12.946 20 12 20s-1.773 0-2.5-.018c-1.573-.04-2.677-.167-3.5-.567a3 3 0 0 1-.828-.587C4.108 17.765 4.009 16.114 4 13V9c.01-3.114.108-4.765 1.172-5.828"
          clipRule="evenodd"
          opacity=".5"
        />
        <path
          fill="white"
          d="M17.75 16a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0 0 1.5H17a.75.75 0 0 0 .75-.75m-11.5 0a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75M5.5 9.5c0 1.414 0 2.121.44 2.56c.439.44 1.146.44 2.56.44h7c1.414 0 2.121 0 2.56-.44c.44-.439.44-1.146.44-2.56V7c0-1.414 0-2.121-.44-2.56C17.622 4 16.915 4 15.5 4h-7c-1.414 0-2.121 0-2.56.44C5.5 4.878 5.5 5.585 5.5 7zm-3.1 2.3L4 13V9H3a1 1 0 0 0-1 1v1a1 1 0 0 0 .4.8M21 9h-1.001L20 13l1.6-1.2a1 1 0 0 0 .4-.8v-1a1 1 0 0 0-1-1"
        />
      </svg>
    ),
  },
  {
    key: "government",
    id: nanoid(),
    category: "governmentServices",
    href: "#",
    variant: "teal-ocean",
    icon: <BdMailbox className="size-full! text-white!" />,
  },
  {
    key: "legal",
    id: nanoid(),
    category: "legalServices",
    href: "#",
    variant: "sunset-gold",
    icon: <BdClipboardCheck className="size-full! text-white!" />,
  },
  {
    key: "bills",
    id: nanoid(),
    category: "billsServices",
    href: "#",
    variant: "rose-500",
    icon: <BdBillList className="size-full! text-white!" />,
  },
];

// Footer Links
export const footerLinks: FooterLinkSection[] = [
  {
    id: "contact",
    title: "footer.appDownload",
    items: [
      // {
      //   id: nanoid(),
      //   label: contactUsConfig.phoneNumber[0],
      //   icon: (
      //     <OlPhone size={0} className={cn("text-secondary-main! size-full!")} />
      //   ),
      // },
      {
        id: nanoid(),
        label: contactUsConfig.address,
        icon: (
          <OlMapPointWave
            size={0}
            className={cn("text-secondary-main! size-full!")}
          />
        ),
      },
      {
        id: nanoid(),
        label: contactUsConfig.workingHours,
        icon: (
          <OlClockCircle
            size={0}
            className={cn("text-secondary-main! size-full!")}
          />
        ),
      },
      // {
      //   id: nanoid(),
      //   label: "footer.telegramChannel",
      //   icon: (
      //     <OlPlain size={0} className={cn("text-secondary-main! size-full!")} />
      //   ),
      //   href: "#",
      // },
    ],
  },
  {
    id: "quick-links",
    title: "footer.quickLinks",
    items: [
      {
        id: nanoid(),
        label: "footer.aboutUs",
        href: routes.blog.ABOUT_US.primaryPath,
      },
      {
        id: nanoid(),
        label: "footer.inquiryHistory",
        href: routes.main.INQUIRY_HISTORY.primaryPath,
      },
      {
        id: nanoid(),
        label: "footer.paidBills",
        href: routes.main.BILL_HISTORY.primaryPath,
      },
      {
        id: nanoid(),
        label: "footer.wallet",
        href: routes.main.WALLET.primaryPath,
      },
      {
        id: nanoid(),
        label: "footer.inquiryValidity",
        href: routes.main.INQUIRY_VALIDITY.primaryPath,
      },
      {
        id: nanoid(),
        label: "footer.companyVersion",
        href: "https://hub.novin.one/",
      },
      {
        id: nanoid(),
        label: "footer.services",
        href: routes.main.SERVICES.primaryPath,
      },
      {
        id: nanoid(),
        label: "footer.packages",
        href: routes.main.PACKAGES.primaryPath,
      },
      { id: nanoid(), label: "footer.faq", href: routes.blog.FAQ.primaryPath },
      {
        id: nanoid(),
        label: "footer.licenses",
        href: routes.blog.LICENSES.primaryPath,
      },
      {
        id: nanoid(),
        label: "footer.blog",
        href: routes.blog.BLOG.primaryPath,
      },
    ],
  },
  {
    id: "categories",
    title: "footer.categories",
    items: [
      {
        id: nanoid(),
        label: "footer.bankingServices",
        href: routes.main.SERVICES.primaryPath,
      },
      {
        id: nanoid(),
        label: "footer.vehicleServices",
        href: routes.main.SERVICES.primaryPath,
      },
      {
        id: nanoid(),
        label: "footer.governmentServices",
        href: routes.main.SERVICES.primaryPath,
      },
      {
        id: nanoid(),
        label: "footer.legalServices",
        href: routes.main.SERVICES.primaryPath,
      },
    ],
  },
];

export const footerSocialLinks: FooterSocialLink[] = [
  {
    id: 1,
    title: "footer.social.linkedin",
    href: "https://www.linkedin.com/company/novinone",
    icon: <LinkedinIcon size={26} />,
  },
  {
    id: 2,
    title: "footer.social.instagram",
    href: "https://www.instagram.com/novinoneco",
    icon: <InstagramIcon size={26} />,
  },
  {
    id: 3,
    title: "footer.social.x",
    href: "https://www.x.com/NovinOne",
    icon: <TwitterIcon size={26} />,
  },
  {
    id: 4,
    title: "footer.social.aparat",
    href: "https://www.aparat.com/novin.one",
    icon: <AparatIcon size={26} />,
  },
  {
    id: 5,
    title: "footer.social.telegram",
    href: "https://t.me/novinoneco",
    icon: <TelegramIcon size={26} />,
  },
  {
    id: 6,
    title: "footer.social.telegram",
    href: "https://t.me/novinone_bot",
    icon: <BotIcon size={26} />,
  },
  // {
  //   id: 6,
  //   title: "footer.social.bale",
  //   href: "http://ble.ir/novinoneco",
  //   icon: <BaleIcon size={25} />,
  // },
];

// Steps
export const steps: Omit<IStepCardProps, "index">[] = [
  {
    id: nanoid(),
    title: "steps.step1.title",
    description: "steps.step1.description",
    link: {
      id: nanoid(),
      href: routes.blog.ABOUT_US.primaryPath,
      label: "steps.step1.moreInfo",
    },
  },
  {
    id: nanoid(),
    title: "steps.step2.title",
    description: "steps.step2.description",
    link: {
      id: nanoid(),
      href: routes.blog.ABOUT_US.primaryPath,
      label: "steps.step2.moreInfo",
    },
  },
  {
    id: nanoid(),
    title: "steps.step3.title",
    description: "steps.step3.description",
    link: {
      id: nanoid(),
      href: routes.blog.ABOUT_US.primaryPath,
      label: "steps.step3.moreInfo",
    },
  },
];

// FAQ Items
export const FaqItems: FaqItem[] = [
  {
    id: nanoid(),
    title: "سامانه استعلام نوین چیست و چگونه کار می‌کند؟",
    content:
      "سامانه نوین پلتفرم آنلاین و رسمی‌ای است که با اتصال به بانک‌ها، سازمان‌های دولتی و مراجع قانونی، امکان دریافت اطلاعات رسمی مورد نیاز را در کوتاه‌ترین زمان فراهم می‌کند. شما با ثبت‌نام و ورود به سامانه، می‌توانید در سه قدم ساده (واردکردن اطلاعات، انتخاب خدمت، پرداخت هزینه) اقدام به استعلام کنید و پاسخ را همان لحظه مشاهده نمایید.",
  },
  {
    id: nanoid(),
    title: "چه اطلاعاتی را می‌توانم از طریق این سامانه استعلام کنم؟",
    content:
      "خدمات سامانه شامل استعلام‌های مالی (مانند وضعیت چک برگشتی، تبدیل کارت به شماره شبا، استعلام شناسه شبا و بررسی تراکنش‌های بانکی) و استعلام‌های دولتی/حقوقی (مانند استعلام خلافی خودرو، وضعیت نظام وظیفه و اطلاعات شرکت با شناسه ملی) است با ورود شناسه مربوط به هر خدمت (مثلاً کد ملی، شماره کارت یا شماره شبا) می‌توانید گزارش کامل مورد نظر را دریافت کنید.",
  },
  {
    id: nanoid(),
    title: "هزینه هر استعلام چقدر است؟",
    content:
      "هزینه خدمات به نوع استعلام بستگی دارد. برخی استعلام‌ها رایگان هستند و برخی دیگر با هزینه‌ای اندک ارائه می‌شوند. در هر صورت، پیش از نهایی کردن درخواست، میزان دقیق هزینه خدمت به شما نمایش داده خواهد شد.",
  },
  {
    id: nanoid(),
    title: "پاسخ استعلام معمولاً چقدر طول می‌کشد؟",
    content:
      "نتیجه استعلام همواره به صورت آنی و در لحظه قابل رویت است و پس از وارد کردن اطلاعات مرتبط با هر سرویس میتوانید پس از پرداخت هزینه، نتیجه استعلام سرویس مورد نظر را مشاهده نمایید.",
  },
  {
    id: nanoid(),
    title: "چگونه اطمینان حاصل کنم اطلاعات واردشده و پاسخ استعلام امن باشند؟",
    content:
      "سامانه نوین با استفاده از پروتکل‌های امنیتی استاندارد و اتصال مستقیم به منابع رسمی، از صحت و محرمانگی داده‌ها اطمینان حاصل می‌کند. تمامی اطلاعات شخصی و بانکی کاربران رمزنگاری شده و پس از ارائه جواب، از سرورها حذف می‌شوند.",
  },
  {
    id: nanoid(),
    title: "آیا می‌توانم برای شخص دیگری نیز استعلام بگیرم؟",
    content:
      "در بسیاری از موارد بله؛ کافی است اطلاعات هویتی یا حساب آن شخص را داشته باشید. به عنوان مثال، برای استعلام چک برگشتی می‌توانید با واردکردن کد ملی و شماره موبایل صاحب چک (با رضایت او) گزارش وضعیت اعتباری او را دریافت کنید. در سایر خدمات نیز با داشتن شناسه مرتبط امکان استعلام بدون مراجعه حضوری وجود دارد.",
  },
  {
    id: nanoid(),
    title: "چه خدماتی در سامانه استعلام نوین ارائه میشود؟",
    content:
      "در سامانه استعلام نوین انواع خدمات بانکی نظیر استعلام چک برگشتی با جزئیات، استعلام شماره شبا، تبدیل شماره کارت به شبا، تبدیل شماره حساب به شبا و استعلام حساب بانکی قابل ارائه میباشد. همچنین خدمات خودرویی مانند استعلام خلافی خودرو، استعلام بیمه شخص ثالث، پرداخت بدهی عوارض، استعلام پلاک و غیره نیز قابل استعلام است، در بخش خدمات دولتی، استعلاماتی نظیر استعلام وظعیت نظام وظیفه، استعلام کد پستی، استعلام ممنوع الخروجی و غیره نیز توسط سامانه نوین ارائه میگردد و در بخش خدمات حقوقی میتوانید از استعلام هایی نظیر استعلام اطلاعات شرکت حقوقی، استعلام استعلام روزنامه رسمی و غیره نیز بهره‌مند شوید.",
  },
  {
    id: nanoid(),
    title: "جهت استعلام خدمات سامانه نوین چه مشخصاتی مورد نیاز است؟",
    content:
      "هرکدام از خدمات ارالئه شده توسط سامانه استعلام نوین نیازمند مشخصات و موارد مرتبط با خود آن سرویس است بعنوان مثال در زمینه خدمات خودرویی علاوه بر کد ملی شخص دارنده خودرو موارد مرتبط با استعلام خودرویی نیز مورد نیاز است اما در خدمات بانکی و سرویس تبدیل شماره کارت به شبا نیازمند وارد نمودن شماره کارت بانکی شخص مورد نظر است.",
  },
  {
    id: nanoid(),
    title: "سامانه نوین چطور کار میکند؟",
    content:
      "سامانه استعلام نوین یک ارائه دهنده خدمات غیر حضوری بر پایه استعلام است، سامانه نوین در تلاش است تا با ارائه خدمات استعلامی به صورت آنی و بدون فوت وقت به کاربرانش اطلاعات مورد نیازشان را ارائه دهد. سامانه استعلام نوین با اتصال به سرویس دهنده های هرکدام از خدمات ارائه شده به صورت مستقیم و بدون واسطه اقدام به استعلام خدمات بانکی، خودرویی، حقوقی و دولتی مینماید و هرکدام را از سامانه های رسمی و با حفظ محرمانگی اطلاعات انجام میدهد.",
  },
  {
    id: nanoid(),
    title: "فرآیند استعلام چه مدت زمان میبرد؟",
    content:
      "سامانه نوین با هدف ارائه نتایج استعلامی در سریعترین زمان ممکن و بدون معطلی شروع به کار نموده و همواره دقت و سرعت را در هر استعلام چاشنی کار کرده است، فرآیند هر استعلام در سامانه نوین به این شکل است: انتخاب سرویس، تکمیل فرم مشخصات، پرداخت، مشاهده نتیجه. همچنین جهت سهولت کار و عدم از بین رفتن نتیجه استعلام، کلیه استعلامات از بخش تاریخچه استعلام قابل رویت است و میتوانید کلیه استعلامات سابق خود را از آن بخش مشاهده نمایید.",
  },
];

// Date Options
const currentYear = parseInt(
  faToEnDigits(
    new Intl.DateTimeFormat("fa-IR", { year: "numeric" }).format(new Date()),
  ),
);
export const dateDropdownOptions: {
  key: TDatePartKey;
  label: string;
  items: string[];
}[] = [
  {
    key: "day",
    label: "روز",
    items: Array.from({ length: 31 }, (_, i) => String(i + 1)),
  },
  {
    key: "month",
    label: "ماه",
    items: [
      "فروردین",
      "اردیبهشت",
      "خرداد",
      "تیر",
      "مرداد",
      "شهریور",
      "مهر",
      "آبان",
      "آذر",
      "دی",
      "بهمن",
      "اسفند",
    ],
  },
  {
    key: "year",
    label: "سال",
    items: Array.from({ length: currentYear - 1403 + 1 }, (_, i) =>
      String(1403 + i),
    ),
  },
];
export const WalletTransactionsTableHeaders = [
  { key: "status", label: "walletTransactions.status" },
  // { key: "type", label: "walletTransactions.type" },
  { key: "description", label: "walletTransactions.description" },
  { key: "track_id", label: "walletTransactions.trackId" },
  { key: "amount", label: "walletTransactions.amount" },
  { key: "date", label: "walletTransactions.date" },
  { key: "time", label: "walletTransactions.time" },
];

export const teamMembers: TeamMember[] = [
  {
    image: Image01,
    name: "teamMembers.arashName",
    role: "teamMembers.arashRole",
  },
  {
    image: Image02,
    name: "teamMembers.liamName",
    role: "teamMembers.liamRole",
  },
  {
    image: Image03,
    name: "teamMembers.sinaName",
    role: "teamMembers.sinaRole",
  },
  {
    image: Image01,
    name: "teamMembers.arashName",
    role: "teamMembers.arashRole",
  },
  {
    image: Image02,
    name: "teamMembers.liamName",
    role: "teamMembers.liamRole",
  },
  {
    image: Image03,
    name: "teamMembers.sinaName",
    role: "teamMembers.sinaRole",
  },
];
export const ourValues: IOurValueItem[] = [
  {
    title: "ourValues.simplicity",
    description: "ourValues.simplicityDescription",
    icon: <OlLayers className={cn("text-custom-main-light! size-full!")} />,
  },
  {
    title: "ourValues.quickResponse",
    description: "ourValues.quickResponseDescription",
    icon: (
      <OlUsersGroupRounded
        className={cn("text-custom-main-light! size-full!")}
      />
    ),
  },
  {
    title: "ourValues.accuracyAndSecurity",
    description: "ourValues.accuracyAndSecurityDescription",
    icon: <OlHourglass className={cn("text-custom-main-light! size-full!")} />,
  },
];

export interface BankOption {
  label: string;
  value: string;
}

export const BANK_OPTIONS: BankOption[] = [
  { label: "بانک کارآفرین", value: "KARAFARIN" },
  { label: "بانک پارسیان", value: "PARSIAN" },
  { label: "بانک اقتصاد نوین", value: "EGHTESAD_NOVIN" },
  { label: "بانک سامان", value: "SAMAN" },
  { label: "بانک پاسارگاد", value: "PASARGAD" },
  { label: "بانک سرمایه", value: "SARMAYEH" },
  { label: "بانک سینا", value: "SINA" },
  { label: "بانک مهر ایران", value: "MEHR_IRAN" },
  { label: "بانک شهر", value: "SHAHR" },
  { label: "بانک آینده", value: "AYANDEH" },
  { label: "بانک گردشگری", value: "GARDESHGARI" },
  { label: "بانک دی", value: "DAY" },
  { label: "بانک ایران زمین", value: "IRANZAMIN" },
  { label: "بانک رسالت", value: "RESALAT" },
  { label: "بانک ملل", value: "MELAL" },
  { label: "بانک خاورمیانه", value: "KHAVARMIANEH" },
  { label: "بانک نور", value: "NOOR" },
  { label: "بانک ایران و ونزوئلا", value: "IRAN_VENEZUELA" },
  { label: "بانک مرکزی", value: "MARKAZI" },
  { label: "بانک صنعت و معدن", value: "SANAT_VA_MADAN" },
  { label: "بانک ملت", value: "MELLAT" },
  { label: "بانک رفاه", value: "REFAH" },
  { label: "بانک مسکن", value: "MASKAN" },
  { label: "بانک سپه", value: "SEPAH" },
  { label: "بانک کشاورزی", value: "KESHAVARZI" },
  { label: "بانک ملی", value: "MELLI" },
  { label: "بانک تجارت", value: "TEJARAT" },
  { label: "بانک صادرات", value: "SADERAT" },
  { label: "بانک توسعه صادرات", value: "TOSEAH_SADERAT" },
  { label: "پست بانک", value: "POST" },
  { label: "بانک توسعه تعاون", value: "TOSEAH_TAAVON" },
  { label: "بانک توسعه", value: "TOSEAH" },
];

export const mobileNavBarItems: IBaseIconLabel[] = [
  {
    id: "home",
    label: "mobileNav.home",
    href: routes.main.HOME.primaryPath,
    icon: <BdHome className="size-full!" />,
  },
  {
    id: "services",
    label: "mobileNav.services",
    icon: <BdWidget className="size-full!" />,
  },
  {
    id: "company-version",
    label: "mobileNav.companyVersion",
    icon: (
      <span className="size-full!">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7 5h4c1.886 0 2.828 0 3.414.586S15 7.114 15 9v12.25h7a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1 0-1.5h1V9c0-1.886 0-2.828.586-3.414S5.114 5 7 5M5.25 8A.75.75 0 0 1 6 7.25h6a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 8m0 3a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75m0 3a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75M9 18.25a.75.75 0 0 1 .75.75v2.25h-1.5V19a.75.75 0 0 1 .75-.75"
            clipRule="evenodd"
          />
          <path
            fill="currentColor"
            d="M15 2h2c1.886 0 2.828 0 3.414.586S21 4.114 21 6v15.25h-6V9c0-1.886 0-2.828-.586-3.414C13.842 5.013 12.928 5 11.126 5V3.5c.084-.387.225-.68.46-.914C12.17 2 13.114 2 15 2"
            opacity=".5"
          />
        </svg>
      </span>
    ),
    href: "https://hub.novin.one/",
  },
];
export const statsStaticData = [
  {
    label: "stats.thousandUsers",
    value: "100",
    description: "stats.activeUsers",
  },
  {
    label: "stats.transactions",
    value: "50",
    description: "stats.successfulPerMonth",
  },
  { label: "stats.years", value: "3", description: "stats.experience" },
  {
    label: "stats.companies",
    value: "20",
    description: "stats.trustedPartners",
  },
];

export const socialMedia: IContactSupport[] = [
  {
    key: "facebook",
    id: nanoid(),
    href: "#",
    icon: "/svg/socialMedia/facebook.svg",
  },
  {
    key: "youtube",
    id: nanoid(),
    href: "#",
    icon: "/svg/socialMedia/youtube.svg",
  },
  {
    key: "instagram",
    id: nanoid(),
    href: "#",
    icon: "/svg/socialMedia/instagram.svg",
  },
  {
    key: "telegram",
    id: nanoid(),
    href: "#",
    icon: "/svg/socialMedia/telegram.svg",
  },
  {
    key: "x",
    id: nanoid(),
    href: "#",
    icon: "/svg/socialMedia/x.svg",
  },
  {
    key: "linkedin",
    id: nanoid(),
    href: "#",
    icon: "/svg/socialMedia/linkedin.svg",
  },
];

export const freeServices: IServiceCard[] = [
  {
    id: nanoid(),
    category: "freeServices",
    categoryIcon: <BdWadOfMoney />,
    variant: "yellow-500",
    services: [
      {
        id: nanoid(),
        href: routes.services.Convert_Money_Inquiry.rewritePath,
        icon: <BdSquareTransferHorizontal className="size-full" />,
        label: "تبدیل واحد پول",
        disabled: "active",
        flag: "convert_money",
      },
      {
        id: nanoid(),
        href: routes.services.Pelak_Yab_Inquiry.rewritePath,
        icon: <BdMinimalisticMagnifer className="size-full" />,
        label: "پلاک یاب",
        disabled: "active",
        flag: "pelak_yab",
      },
      {
        id: nanoid(),
        href: routes.services.Inflation_Calculator.rewritePath,
        icon: <BdCalculator className="size-full" />,
        label: "ماشین حساب تورم",
        disabled: "active",
        flag: "inflation_calculator",
      },
      {
        id: nanoid(),
        href: routes.services.Deposit_Interest_Calculator.rewritePath,
        icon: <BdCalculator className="size-full" />,
        label: "محاسبه سود سپرده بانکی",
        disabled: "active",
        flag: "deposit_interest_calculator",
      },
      {
        id: nanoid(),
        href: routes.services.Age_Calculator.rewritePath,
        icon: <BdCalendar className="size-full" />,
        label: "محاسبه سن آنلاین",
        disabled: "active",
        flag: "age_calculator",
      },
      {
        id: nanoid(),
        href: routes.services.Payroll_Calculator_1405.rewritePath,
        icon: <BdCalculator className="size-full" />,
        label: "ماشین حساب حقوق و دستمزد ۱۴۰۵",
        disabled: "active",
        flag: "payroll_calculator_1405",
      },
    ],
  },
];

export const paymentGateways: ISelectableBaseProps[] = [
  {
    label: "درگاه بانک ملی (سداد)",
    isSelected: true,
    icon: SadadImage,
    key: "sadad",
  },
  { label: "درگاه زیبال", isSelected: false, icon: ZibalImage2, key: "zibal" },
];

export const GATEWAY_SETTINGS_MAP: Record<string, keyof IRawSettingsResData> = {
  sadad: "payment_sadad_active",
  zibal: "payment_zibal_active",
};
